import { apiClient } from './api-client';

export interface RestaurantGroup {
  id: string;
  name: string;
  fb: string[];
  ig: string[];
  ga4: string[];
}

let cached: RestaurantGroup[] | null = null;
let loading: Promise<RestaurantGroup[]> | null = null;

export async function getGroupsAsync(): Promise<RestaurantGroup[]> {
  if (cached) return cached;
  if (loading) return loading;

  loading = apiClient.get<RestaurantGroup[]>('/restaurant-groups')
    .then((groups) => { cached = groups; loading = null; return groups; })
    .catch(() => { loading = null; return []; });
  return loading;
}

export function getGroups(): RestaurantGroup[] {
  return cached ?? [];
}

export function invalidateGroups(): void {
  cached = null;
  loading = null;
}

/** Returns allowed account names for a user's group IDs. */
export function getAllowedAccounts(groupIds: string[]): { fb: string[]; ig: string[]; ga4: string[] } {
  const groups = getGroups();

  if (groupIds.includes('all')) {
    return {
      fb: groups.flatMap((g) => g.fb),
      ig: groups.flatMap((g) => g.ig),
      ga4: groups.flatMap((g) => g.ga4),
    };
  }
  const selected = groups.filter((g) => groupIds.includes(g.id));
  return {
    fb: selected.flatMap((g) => g.fb),
    ig: selected.flatMap((g) => g.ig),
    ga4: selected.flatMap((g) => g.ga4),
  };
}
